import React from "react";
import FamilyDetail from "../../family/FamilyDetails/FamilyDetails";

export default function MemberFamilyDetails() {
  return <FamilyDetail />;
}
